var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ds-custom-query-logic-group",
      class: { "ds-custom-query-logic-group__expand": _vm.expand },
    },
    [
      _c(
        "span",
        {
          staticClass: "ds-custom-query-logic-group-join",
          on: {
            click: _vm.changeLogic,
            mousedown: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.getLogicStr()) + " ")]
      ),
      !_vm.data.isRoot
        ? _c(
            "span",
            {
              staticClass: "ds-custom-query-logic-group-expand",
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              !_vm.expand
                ? _c("DsfIcon", {
                    attrs: { name: "jia", title: "展开" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.expandHandler.apply(null, arguments)
                      },
                    },
                  })
                : _c("DsfIcon", {
                    attrs: { name: "jian", title: "折叠" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.expandHandler.apply(null, arguments)
                      },
                    },
                  }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expand,
              expression: "expand",
            },
          ],
          staticClass: "ds-custom-query-logic-group-box",
        },
        [
          _c("div", { staticClass: "ds-custom-query-logic-group-brackets" }),
          _c(
            "div",
            { staticClass: "ds-custom-query-logic-items" },
            [
              _vm._l(_vm.data.items, function (item, $index) {
                return [
                  _c("DsfCustomQuerySplit", {
                    key: item.$hash + "—before",
                    attrs: { data: item, pos: "before" },
                  }),
                  _c("DsfCustomQueryLogicNode", {
                    key: item.$hash,
                    attrs: { data: item },
                  }),
                  $index == _vm.data.items.length - 1
                    ? _c("DsfCustomQuerySplit", {
                        key: item.$hash + "-after",
                        attrs: { data: item, pos: "after" },
                      })
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.expand,
              expression: "!expand",
            },
          ],
          staticClass: "ds-custom-query-logic-group-box-contract",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.expandHandler.apply(null, arguments)
            },
          },
        },
        [
          _c("span", { attrs: { title: "展开" } }, [
            _vm._v(_vm._s(_vm.data.items.length + "个子条件")),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }